"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/** @module resolve */ /** for typedoc */
__export(require("./interface"));
__export(require("./resolvable"));
__export(require("./resolveContext"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ui-router-core/lib/resolve/index.js
// module id = 134
// module chunks = 2